import { gql } from '@apollo/client';

export const UPSERT_CURRENCY_GROUP = gql`
  mutation upsertCurrencyGroup($input: UpsertCurrencyGroupInput!) {
    currencyGroup: upsertCurrencyGroup(input: $input) {
      id
    }
  }
`;
